import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Most server data in this app doesn't change often (master data, timesheet).
      // 30s fresh, 5min cache is a sane default. Override per-query as needed.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Don't retry auth failures — there's no point.
        const code = (error as { code?: string }).code;
        if (code === 'AUTH_INVALID' || code === 'AUTH_FORBIDDEN' || code === 'VALIDATION_FAILED') {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
